import script from "./start-election-button.vue?vue&type=script&lang=js"
export * from "./start-election-button.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__